/* OMAD'S : ecran de resultat du diagnostic (coffret sur mesure, valeur barree, ajout au panier).

   POURQUOI CE FICHIER. Le resultat ecrivait ses prix en dur (74,90 / 101,87 / 127,31 EUR) alors que
   les coffrets personnalises vendus sont a 59 / 74 / 93 EUR : 4 705 diagnostics en 30 jours
   affichaient des prix faux. Ici RIEN n'est ecrit en dur : prix, prix barres et disponibilites
   viennent de `/products/<handle>.js` (Ajax Product API, lu en direct, devise du marche).

   Le fichier est volontairement SANS acces au DOM dans `planifier` : c'est la partie qui decide de
   la valeur barree, et elle se teste sous Node avec de vrais prix (scripts/test-diagnostic-resultat.js).

   Regles de calcul (maquette v5 validee par Julien) :
   - valeur barree = produits au plein tarif + ebooks offerts de CE coffret + cadeau mystere +
     livraison, chaque cadeau compte seulement si le panier APRES le code -10 % le debloque ;
   - sous le seuil de livraison, un produit qui fait passer la barre est toujours propose ;
   - un article en rupture n'est jamais ajoute (un seul article indisponible fait echouer tout
     /cart/add.js) ; coffret indisponible = ses composants (spray(s) + shampoing) a la place. */
(function (root) {
  'use strict';

  /* Les handles ne se traduisent jamais : ce sont des cles techniques. */
  var H = {
    spray: 'soin',
    shampoing: {
      vanille: 'shampoing-blond-vanille',
      miel: 'shampoing-blond-miel',
      violet: 'le-shampoing-violet-anti-reflets-roux-omads',
      bleu: 'shampoing-bleu'
    },
    coffret: {
      vanille: 'coffret-personnalise-vanille',
      miel: 'coffret-personnalise-miel',
      jaune: 'coffret-personnalise-polaire',
      roux: 'coffret-personnalise-anti-roux'
    },
    serum: 'huile-nourrissante',
    peigne: 'peigne-3-dimensions-pour-des-meches-parfaites',
    brosse: 'la-brosse-pour-des-cheveux-lisse-et-soyeux',
    pince: 'pince-anti-casse',
    booster: 'complement-alimentaire',
    cadeau: 'cadeau-mystere-1'
  };

  /* Cles d'ajout proposees sous le seuil de livraison (le serum a sa propre ligne). */
  var ADDONS = ['peigne', 'brosse', 'pince', 'booster'];

  /* Un handle ne se charge qu'une fois : un doublon = un appel /products/<handle>.js de trop. */
  function sansDoublon(l) {
    return l.filter(function (h, i) { return h && l.indexOf(h) === i; });
  }

  function tousLesHandles() {
    var l = [H.spray, H.serum, H.peigne, H.brosse, H.pince, H.booster, H.cadeau];
    Object.keys(H.shampoing).forEach(function (k) { l.push(H.shampoing[k]); });
    Object.keys(H.coffret).forEach(function (k) { l.push(H.coffret[k]); });
    return sansDoublon(l);
  }

  /* Handles a charger pour CES reponses (pas les 20 : un aller-retour reseau par fiche). */
  function handlesPour(cfg, rep) {
    var nu = nuance(rep);
    var l = [H.spray, H.shampoing[nu.shampoing], H.coffret[nu.cle], H.cadeau, H.serum].concat(ADDONS.map(function (k) { return H[k]; }));
    return sansDoublon(l.concat(cfg.ebooks.commun || [], cfg.ebooks.chaud || [], cfg.ebooks.polaire || []));
  }

  /* Prix de reference (plein tarif) d'une variante : le barre de Shopify s'il existe. */
  function plein(v) {
    return (v.compare_at_price && v.compare_at_price > v.price) ? v.compare_at_price : v.price;
  }

  /* Nuance a partir des reponses. Le quiz ne propose que vanille, miel et polaire :
     polaire depuis un chatain ou un brun fait ressortir du roux (bleu), depuis un blond
     du jaune (violet). */
  function nuance(rep) {
    var t = rep.target_shade;
    if (t === 'Blond Vanille') return { cle: 'vanille', shampoing: 'vanille' };
    if (t === 'Blond Miel') return { cle: 'miel', shampoing: 'miel' };
    if (rep.hair_color === 'Châtain' || rep.hair_color === 'Brun') return { cle: 'roux', shampoing: 'bleu' };
    return { cle: 'jaune', shampoing: 'violet' };
  }

  function longueur(rep) {
    var i = { 'Courts': 0, 'Mi-longs': 1, 'Longs': 2 }[rep.hair_length];
    if (i === undefined) i = 1;
    return { index: i, sprays: i + 1, cle: ['solo', 'duo', 'trio'][i] };
  }

  function variante(produit, index) {
    if (!produit || !produit.variants) return null;
    return produit.variants[index] || null;
  }

  /* Prix (centimes) apres le code. Arrondi au centime, comme Shopify. */
  function apresCode(cents, pct) {
    return Math.round(cents * (100 - pct) / 100);
  }

  /* Ebooks offerts : les 2 communs, puis 1 selon la famille de nuance.
     Un coffret indisponible vendu en composants (spray) ne declenche que les communs. */
  function listeEbooks(cfg, nu, modeCoffret) {
    var l = (cfg.ebooks.commun || []).slice();
    if (modeCoffret) {
      var g = (nu.cle === 'vanille' || nu.cle === 'miel') ? cfg.ebooks.chaud : cfg.ebooks.polaire;
      l = l.concat(g || []);
    }
    return l;
  }

  /* opts : { serum: bool|undefined (defaut = coche si cassants), addon: cle|null } */
  function planifier(cfg, cat, rep, opts) {
    opts = opts || {};
    var nu = nuance(rep);
    var lg = longueur(rep);
    var shHandle = H.shampoing[nu.shampoing];

    var spray = variante(cat[H.spray], lg.index);
    var sham = variante(cat[shHandle], 0);
    var coffretProd = cat[H.coffret[nu.cle]];
    var coffretVar = variante(coffretProd, lg.index);
    var modeCoffret = !!(coffretVar && coffretVar.available);

    var plan = { nuance: nu, longueur: lg, modeCoffret: modeCoffret, lignes: [], variantes: [], ajoutable: false };

    /* Ligne 1 : sprays. Ligne 2 : shampoing. Prix affiches = plein tarif. */
    plan.lignes.push({ cle: 'spray', plein: spray ? plein(spray) : 0, handle: H.spray });
    plan.lignes.push({ cle: 'shampoing', plein: sham ? plein(sham) : 0, handle: shHandle });

    var panier = 0;
    plan.composants = [];
    if (spray && spray.available) plan.composants.push(spray.id);
    if (sham && sham.available) plan.composants.push(sham.id);
    var produitsPlein = (spray ? plein(spray) : 0) + (sham ? plein(sham) : 0);
    if (modeCoffret) {
      panier = coffretVar.price;
      plan.variantes.push(coffretVar.id);
    } else {
      if (spray && spray.available) { panier += spray.price; plan.variantes.push(spray.id); }
      if (sham && sham.available) { panier += sham.price; plan.variantes.push(sham.id); }
    }

    /* Ligne 3 : serum, seulement si les cheveux sont cassants ou abimes et qu'il est en stock. */
    var serumVar = variante(cat[H.serum], 0);
    var cassants = rep.hair_health === 'Cassants ou abîmés';
    var serumDispo = !!(serumVar && serumVar.available);
    plan.serum = { visible: cassants && serumDispo, dispo: serumDispo, cassants: cassants, plein: serumVar ? plein(serumVar) : 0, prix: serumVar ? serumVar.price : 0 };
    plan.serum.coche = plan.serum.visible && (opts.serum === undefined ? true : !!opts.serum);
    if (plan.serum.coche) {
      panier += serumVar.price;
      produitsPlein += plein(serumVar);
      plan.variantes.push(serumVar.id);
    }

    /* Ebooks (valeur seulement : leur prix vient de la fiche Shopify de chaque ebook). */
    var ebooks = [];
    var ebTotal = 0;
    listeEbooks(cfg, nu, modeCoffret).forEach(function (h) {
      var v = variante(cat[h], 0);
      if (!v) return;
      ebooks.push({ handle: h, prix: v.price, produit: cat[h] });
      ebTotal += v.price;
    });
    plan.ebooks = { items: ebooks, total: ebTotal };

    /* Ajout propose sous le seuil de livraison, juge sur le panier SANS cet ajout. */
    var baseApres = apresCode(panier, cfg.codePct);
    plan.addon = null;
    if (baseApres < cfg.seuilLivraison) {
      var ordre = [];
      if (rep.uniformity === 'Mèches / balayage') ordre.push('peigne');
      if (rep.hair_health === 'Graissent trop vite') ordre.push('brosse');
      var dispo = ADDONS.map(function (k) {
        var v = variante(cat[H[k]], 0);
        return (v && v.available && apresCode(panier + v.price, cfg.codePct) >= cfg.seuilLivraison) ? { cle: k, v: v } : null;
      }).filter(Boolean);
      var choisi = null;
      ordre.forEach(function (k) {
        if (!choisi) dispo.forEach(function (d) { if (d.cle === k) choisi = d; });
      });
      if (!choisi && dispo.length) {
        dispo.sort(function (a, b) { return a.v.price - b.v.price; });
        choisi = dispo[0];
      }
      if (choisi) {
        plan.addon = {
          cle: choisi.cle, handle: H[choisi.cle], prix: choisi.v.price, plein: plein(choisi.v),
          variantId: choisi.v.id, manque: cfg.seuilLivraison - baseApres,
          coche: opts.addon === choisi.cle, produit: cat[H[choisi.cle]]
        };
        if (plan.addon.coche) {
          panier += choisi.v.price;
          produitsPlein += plan.addon.plein;
          plan.variantes.push(choisi.v.id);
        }
      }
    }

    var apres = apresCode(panier, cfg.codePct);
    var cadeauVar = variante(cat[H.cadeau], 0);
    var mystereOk = !!(cadeauVar && cadeauVar.available && apres >= cfg.seuilCadeau);
    var mystereVal = cadeauVar ? plein(cadeauVar) : 0;
    var livraisonOk = apres >= cfg.seuilLivraison;

    var valeur = produitsPlein + ebTotal + (mystereOk ? mystereVal : 0) + (livraisonOk ? cfg.livraisonValeur : 0);
    plan.panier = panier;
    plan.apresCode = apres;
    plan.produitsPlein = produitsPlein;
    plan.mystere = { debloque: mystereOk, valeur: mystereVal };
    plan.livraison = { debloquee: livraisonOk, valeur: cfg.livraisonValeur };
    plan.valeur = valeur;
    plan.remisePct = valeur > panier ? Math.floor((valeur - panier) / valeur * 100) : 0;
    /* Ajout strict : en mode composants (coffret indisponible), le bouton n'est actif que si le
       spray (bonne quantite) ET le shampoing de la nuance sont disponibles. Un panier a moitie
       rempli (un spray sans son shampoing) ne correspond pas a ce que le resultat promet. */
    plan.ajoutable = modeCoffret
      ? plan.variantes.length > 0
      : !!(spray && spray.available && sham && sham.available);
    return plan;
  }

  var api = { H: H, tousLesHandles: tousLesHandles, handlesPour: handlesPour, nuance: nuance, longueur: longueur, planifier: planifier, plein: plein, apresCode: apresCode };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  root.OmadsDiagResultat = api;
})(typeof window !== 'undefined' ? window : globalThis);
